module.exports = __webpack_public_path__ + "assets/img/Inter-Medium.svg?07a11a2de02818fffb99d81391d3632f";